export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-5.8161b79e.png";